import axios from 'axios';

// The entry (index.jsx) calls setupAxios, which sets the '/api' baseURL, so paths
// here omit the '/api' prefix (matching the login/logout service convention).
export const resendVerificationEmail = (email) => {
  return axios.post('/auth/email/resend/verification', { email });
};
